/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarycopylink3Inputs */

const en_medialibrarycopylink3 = /** @type {(inputs: Medialibrarycopylink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy link`)
};

const de_medialibrarycopylink3 = /** @type {(inputs: Medialibrarycopylink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link kopieren`)
};

/**
* | output |
* | --- |
* | "Copy link" |
*
* @param {Medialibrarycopylink3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarycopylink3 = /** @type {((inputs?: Medialibrarycopylink3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarycopylink3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarycopylink3(inputs)
	return de_medialibrarycopylink3(inputs)
});
export { medialibrarycopylink3 as "mediaLibraryCopyLink" }